module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/cooking/knife-fork-1-d3208e121f3b48e3e399f3f63bc8fe45.svg";